console.log("LEARNMORE LOADED")
window.addEventListener('DOMContentLoaded', function () {
  const isShowPopupOnLearnMore =
    nvdConsentConfig?.standard_widget?.heading?.section_content
      ?.show_popup_on_learn_more

    const popupData =
      nvdConsentConfig.standard_widget.learn_more_popup.section_content
    const popupStyles =
      nvdConsentConfig.standard_widget.learn_more_popup.section_style
    const popupCSS = `
       .nvd-learnmore-popup-overlay * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
      }
      .nvd-learnmore-popup-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.3);
        backdrop-filter: blur(5px);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;
        opacity: 0;
        visibility: hidden;
        transition: all 0.3s ease;
      }

      .nvd-learnmore-popup-overlay.show {
        opacity: 1;
        visibility: visible;
      }

      .nvd-learnmore-popup-content {
        background-color: #ffffff;
        border-radius: 8px;
        max-width: 500px;
        width: 100%;
        margin: 20px;
        position: relative;
        transform: scale(0.9);
        transition: transform 0.3s ease;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
      }

      .nvd-learnmore-popup-overlay.show .nvd-learnmore-popup-content {
        transform: scale(1);
      }

      .nvd-learnmore-popup-close {
        position: absolute;
        top: 15px;
        right: 15px;
        width: 30px;
        height: 30px;
        border: none;
        background: #ebebeb;
        border-radius: 50%;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        color: #666;
        transition: all 0.2s ease;
      }

      .nvd-learnmore-popup-close:hover {
        background: #ddd;
        color: #333;
      }

      .nvd-learnmore-popup-body {
        padding: 30px;
      }

      .nvd-learnmore-popup-header {
        text-align: center;
        margin-bottom: 30px;
      }

      .nvd-learnmore-popup-heading {
        font-size: 24px;
        font-weight: 600;
        color: #00070b;
        line-height: 1.2;
        margin-bottom: 15px;
      }

      .nvd-learnmore-popup-subheading {
        font-size: 13px;
        font-weight: 400;
        color: #374144;
        line-height: 1.4;
      }

      .nvd-learnmore-popup-features {
        margin-bottom: 30px;
      }

      .nvd-learnmore-feature-item {
        display: flex;
        align-items: flex-start;
        margin-bottom: 20px;
        gap: 12px;
      }

      .nvd-learnmore-feature-icon {
        width: 40px;
        height: 40px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
      }

      .nvd-learnmore-feature-icon img {
        width: 24px;
        height: 24px;
        object-fit: contain;
      }

      .nvd-learnmore-feature-bullet {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: #00070b;
        margin-top: 8px;
        flex-shrink: 0;
      }

      .nvd-learnmore-feature-content {
        flex: 1;
      }

      .nvd-learnmore-feature-title {
        font-size: 16px;
        font-weight: 600;
        color: #00070b;
        margin-bottom: 5px;
      }

      .nvd-learnmore-feature-description {
        font-size: 13px;
        font-weight: 400;
        color: #374144;
        line-height: 1.4;
      }

      .nvd-learnmore-popup-footer {
        text-align: center;
      }

      .nvd-learnmore-footer-description {
        font-size: 12px;
        font-weight: 400;
        color: #374144;
        margin-bottom: 15px;
      }

      .nvd-learnmore-footer-links {
        display: flex;
        justify-content: center;
        gap: 16px;
        flex-wrap: wrap;
      }

      .nvd-learnmore-footer-link {
        font-size: 12px;
        font-weight: 400;
        color: #374144;
        text-decoration: underline;
        cursor: pointer;
        transition: opacity 0.2s ease;
      }

      .nvd-learnmore-footer-link:hover {
        opacity: 0.8;
      }

      .nvd-learnmore-popup-logo {
        text-align: center;
        margin-top: 20px;
      }

      .nvd-learnmore-popup-logo img {
        height: 24px;
        max-width: 100%;
      }

  

      @media (max-width: 600px) {
        .nvd-learnmore-popup-content {
          margin: 10px;
        }

        .nvd-learnmore-popup-body {
          padding: 20px;
        }

        .nvd-learnmore-popup-heading {
          font-size: 20px;
        }

        .nvd-learnmore-footer-links {
          gap: 12px;
        }
      }
    
    `
    function renderFeatures() {
      const featuresContainer = document.getElementById('nvdPopupFeatures')
      featuresContainer.innerHTML = ''
      popupData.popup_features.forEach((feature, index) => {
        const featureItem = document.createElement('div')
        featureItem.className = 'nvd-learnmore-feature-item'

        if (popupData.show_bullet_points) {
          // Render bullet point
          featureItem.innerHTML = `
                        <div class="nvd-learnmore-feature-bullet" style="background-color: ${popupStyles.feature_title_color}"></div>
                        <div class="nvd-learnmore-feature-content">
                            <div class="nvd-learnmore-feature-title" style="color: ${popupStyles.feature_title_color}; font-size: ${popupStyles.feature_title_size}; font-weight: ${popupStyles.feature_title_weight}">
                                ${feature.title}
                            </div>
                            <div class="nvd-learnmore-feature-description" style="color: ${popupStyles.feature_description_color}; font-size: ${popupStyles.feature_description_size}; font-weight: ${popupStyles.feature_description_weight}">
                                ${feature.description}
                            </div>
                        </div>
                    `
        } else if (feature.icon) {
          // Render icon
          featureItem.innerHTML = `
                        <div class="nvd-learnmore-feature-icon">
                            <img src="${feature.icon}" alt="${feature.title}" />
                        </div>
                        <div class="nvd-learnmore-feature-content">
                            <div class="nvd-learnmore-feature-title" style="color: ${popupStyles.feature_title_color}; font-size: ${popupStyles.feature_title_size}; font-weight: ${popupStyles.feature_title_weight}">
                                ${feature.title}
                            </div>
                            <div class="nvd-learnmore-feature-description" style="color: ${popupStyles.feature_description_color}; font-size: ${popupStyles.feature_description_size}; font-weight: ${popupStyles.feature_description_weight}">
                                ${feature.description}
                            </div>
                        </div>
                    `
        } else {
          // No icon or bullet point
          featureItem.innerHTML = `
                        <div class="nvd-learnmore-feature-content">
                            <div class="nvd-learnmore-feature-title" style="color: ${popupStyles.feature_title_color}; font-size: ${popupStyles.feature_title_size}; font-weight: ${popupStyles.feature_title_weight}">
                                ${feature.title}
                            </div>
                            <div class="nvd-learnmore-feature-description" style="color: ${popupStyles.feature_description_color}; font-size: ${popupStyles.feature_description_size}; font-weight: ${popupStyles.feature_description_weight}">
                                ${feature.description}
                            </div>
                        </div>
                    `
        }

        featuresContainer.appendChild(featureItem)
      })
    }

    function renderFooterLinks() {
      const linksContainer = document.getElementById('nvdFooterLinks')
      const linksHTML = popupData.footer_links
        .map(
          (link) => `
                <a href="${link.url}" 
                   target="_blank" 
                   rel="noopener noreferrer" 
                   class="nvd-learnmore-footer-link" 
                   style="color: ${popupStyles.footer_link_color}; font-size: ${popupStyles.footer_link_size}; font-weight: ${popupStyles.footer_link_weight}">
                    ${link.text}
                </a>
            `
        )
        .join('')

      linksContainer.innerHTML = linksHTML
    }

    function renderFooterDescription() {
      const descriptionElement = document.getElementById('nvdFooterDescription')
      if (popupData.footer_description) {
        descriptionElement.innerHTML = `
                    <span style="color: ${popupStyles.footer_description_color}; font-size: ${popupStyles.footer_description_size}; font-weight: ${popupStyles.footer_description_weight}">
                        ${popupData.footer_description}
                    </span>
                `
        descriptionElement.style.display = 'block'
      } else {
        descriptionElement.style.display = 'none'
      }
    }

    function renderLogo() {
      const logoContainer = document.getElementById('nvdPopupLogo')
      if (popupData.popup_logo) {
        logoContainer.innerHTML = `<img src="${popupData.popup_logo}" alt="Navidium" />`
        logoContainer.style.display = 'block'
      } else {
        logoContainer.style.display = 'none'
      }
    }

    function applyPopupStyles() {
      const popupContent = document.querySelector(
        '.nvd-learnmore-popup-content'
      )
      const popupHeading = document.getElementById('nvdPopupHeading')
      const popupSubheading = document.getElementById('nvdPopupSubheading')

      // Apply popup background and border radius
      popupContent.style.backgroundColor = popupStyles.popup_background_color
      popupContent.style.borderRadius = popupStyles.popup_border_radius

      // Apply heading styles
      popupHeading.style.color = popupStyles.popup_heading_color
      popupHeading.style.fontSize = popupStyles.popup_heading_size
      popupHeading.style.fontWeight = popupStyles.popup_heading_weight

      // Apply subheading styles
      popupSubheading.style.color = popupStyles.popup_subheading_color
      popupSubheading.style.fontSize = popupStyles.popup_subheading_size
      popupSubheading.style.fontWeight = popupStyles.popup_subheading_weight
    }
    function hideNvdLearnMorePopup() {
      const overlay = document.getElementById('nvdLearnMorePopupOverlay')
      overlay.classList.remove('show')
      document.body.style.overflow = 'auto'
    }

    function updatePopupContent() {
      document.head.insertAdjacentHTML(
        'beforeend',
        `<style>${popupCSS}</style>`
      )
      document.body.insertAdjacentHTML(
        'beforeend',
        `
            <div class="nvd-learnmore-popup-overlay" id="nvdLearnMorePopupOverlay">
      <div class="nvd-learnmore-popup-content">
        <button class="nvd-learnmore-popup-close" >&times;</button>
        <div class="nvd-learnmore-popup-body">
          <div class="nvd-learnmore-popup-header">
            <h2 class="nvd-learnmore-popup-heading" id="nvdPopupHeading"></h2>
            <p class="nvd-learnmore-popup-subheading" id="nvdPopupSubheading"></p>
          </div>

          <!-- Features -->
          <div class="nvd-learnmore-popup-features" id="nvdPopupFeatures"></div>

          <!-- Footer -->
          <div class="nvd-learnmore-popup-footer">
            <p class="nvd-learnmore-footer-description" id="nvdFooterDescription"></p>
            <div class="nvd-learnmore-footer-links" id="nvdFooterLinks">
              <!-- Footer links will be dynamically inserted here -->
            </div>
          </div>

          <!-- Logo -->
          <div class="nvd-learnmore-popup-logo" id="nvdPopupLogo">
            <!-- Logo will be dynamically inserted here -->
          </div>
        </div>
      </div>
    </div>`
      )
      document.getElementById(
        'nvdPopupHeading'
      ).innerHTML = `${popupData.popup_heading}`
      document.getElementById(
        'nvdPopupSubheading'
      ).innerHTML = `${popupData.popup_subheading}`

      renderFeatures()
      renderFooterLinks()
      renderFooterDescription()
      renderLogo()
      applyPopupStyles()
    }

    // Close popup when clicking outside

    // Initialize popup content
    updatePopupContent()

    window.addEventListener('click', function (event) {
      const triggerArray = Array.from(
        document.querySelectorAll(
          '.nvd-std-widget-learn-more, .nvd-std-widget-learn-more *, .nvd-learn-more, .nvd-learn-more *'
        )
      )

      if (triggerArray.includes(event.target)) {
        event.preventDefault()
        const popupContent = document.getElementById('nvdLearnMorePopupOverlay')
        if (popupContent) {
          popupContent.classList.add('show')
          document.body.style.overflow = 'hidden'
        }
      }
    })
    window.addEventListener('click', function (event) {
      const triggerArray = Array.from(
        document.querySelectorAll(
          '.nvd-learnmore-popup-close,.nvd-learnmore-popup-close *'
        )
      )
      if (triggerArray.includes(event.target)) {
        event.preventDefault()
        hideNvdLearnMorePopup()
      }
    })

    document
      .getElementById('nvdLearnMorePopupOverlay')
      .addEventListener('click', function (e) {
        if (e.target === this) {
          hideNvdLearnMorePopup()
        }
      })

    // Close popup with Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        hideNvdLearnMorePopup()
      }
    })
  
})
